module.exports = __webpack_public_path__ + "static/img/2_6_2.2b270fe7.jpg";